import { createStore, combineReducers } from 'redux';

import moduleReducers from './modules/reducers';

const reducers = combineReducers({
  ...moduleReducers,
});

function storeConfig() {
  return createStore(reducers);
}

// Export store instance for use outside React components (e.g., in axios interceptors)
export const store = createStore(reducers);

export default storeConfig;
